module.exports = __webpack_public_path__ + "img/key.835d6fb2.svg";